/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 16:09:22                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 15:00:21                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * UserListItem: Display user item
*/

/* Imports */
import { Typography } from "@material-tailwind/react";
import UsersAdminActions from "../../../views/super-admin/views/users/UsersAdminActions";
import { t } from "i18next";
import { formatRoles } from "../../../services/utils/utils";
import { OverflowTooltip } from "../../table/TableCellTooltip";
/***/

/**
* UserListItem: Display user item
* @param user - user item to display
* @param onClick - action to do on click
* @param isLast - is last item 
*/
export default function UserListItem({
  user,
  onClick,
  onChange,
  isLast = false,
  isAdminComponent,
  ...rest
}: {
  user: EasyTech.User,
  onClick?: () => void,
  onChange: () => void,
  isLast?: boolean,
  isAdminComponent: boolean
}) {
  const href = `/users/${user.id}`;
  const rolesString = formatRoles(user.roles);

  const handleRowClick = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    if (e.ctrlKey || e.metaKey) {
      window.open(href, "_blank");
      return;
    }
    onClick?.();
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    if (e.button === 1) {
      e.preventDefault();
      window.open(href, "_blank");
    }
  };

  return (
    <tr
      className={`page-list-item${isLast ? " last" : ""}`}
      tabIndex={0}
      style={{ cursor: "pointer" }}
      onClick={handleRowClick}
      onMouseDown={handleMouseDown}
      {...rest}
    >
      <td>
        <OverflowTooltip content={user.lastName || ""} className="et-cell-truncate">
          <Typography variant="small" color="blue-gray">
            {user.lastName || "error"}
          </Typography>
        </OverflowTooltip>
      </td>
      <td>
        <OverflowTooltip content={user.firstName || ""} className="et-cell-truncate">
          <Typography variant="small" color="blue-gray">
            {user.firstName || "error"}
          </Typography>
        </OverflowTooltip>
      </td>
      <td>
        <OverflowTooltip content={user.email || t("common:noEmail")} className="et-cell-truncate">
          <Typography variant="small" color="blue-gray">
            {user.email || t("common:noEmail")}
          </Typography>
        </OverflowTooltip>
      </td>
      <td>
        <OverflowTooltip content={t("common:noPhone")} className="et-cell-truncate">
          <div>
            <i>{t("common:noPhone")}</i>
          </div>
        </OverflowTooltip>
      </td>
      <td>
        <div className="et-cell-wrap">
          {user.roles.length > 0 ? (
            <Typography variant="small" color="blue-gray">
              {rolesString || "-"}
            </Typography>
          ) : (
            <Typography variant="small" color="blue-gray">
              -
            </Typography>
          )}
        </div>
      </td>
      {isAdminComponent && (
        <td className="z-10" data-no-link onClick={e => e.stopPropagation()} onMouseDown={e => e.stopPropagation()}>
          <UsersAdminActions onChange={onChange} user={user} />
        </td>
      )}
    </tr>
  );
}
/***/
